import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useProjects() {
  const [items, setItems] = useState([]);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let on = true;
    api.get("/projects").then((r) => on && setItems(r.data || [])).catch(() => {}).finally(() => on && setReady(true));
    return () => { on = false; };
  }, []);
  return { items, ready };
}

export function useReviews() {
  const [items, setItems] = useState([]);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let on = true;
    api.get("/reviews").then((r) => on && setItems(r.data || [])).catch(() => {}).finally(() => on && setReady(true));
    return () => { on = false; };
  }, []);
  return { items, ready };
}

export function resolveImg(url) {
  if (!url) return url;
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}

export function useGuides() {
  const [items, setItems] = useState([]);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let on = true;
    api.get("/guides").then((r) => on && setItems(r.data || [])).catch(() => {}).finally(() => on && setReady(true));
    return () => { on = false; };
  }, []);
  return { items, ready };
}

export function useGuideCategories() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let on = true;
    api.get("/guide-categories").then((r) => on && setItems(r.data || [])).catch(() => {});
    return () => { on = false; };
  }, []);
  return items;
}
